import React, { Component } from 'react';
import './index.module.less';
import { handleStylePx2rem } from '@helpers/utils';
import ReactSVG from 'react-svg';

declare const require: NodeRequire & {context: Function};
const requireContext = require.context("./assets/images", true, /^\.\/.*\.svg$/);
const images = requireContext.keys().map(requireContext);
const keys = requireContext.keys();

const imageMap: any = {};
keys.forEach((item: string, index: number) => {
  const result = item.match(/\/(.*)\.svg/) as Array<string>;
  imageMap[result[1]] = images[index];
});

export interface IIconProps {
  type: string;
  size?: number;
  color?: string;
  styles?: React.CSSProperties;
  onClick?(): void;
  srcMap?: {[propName: string]: string};
}

interface IIconState {

}

class Icon extends Component<IIconProps, IIconState> {

  constructor(props: IIconProps) {
    super(props);
    this.state = {
    };
  }

  handleClick = () => {
    const { onClick } = this.props;
    onClick && onClick();
  }

  render() {
    const { type, color, size = 24, styles = {}, srcMap = {} } = this.props;
    const image = srcMap[type] || imageMap[type] || '';
    const style: React.CSSProperties = {
      ...styles,
    };
    if (size) {
      style.fontSize = typeof size === 'number' ? `${size}px` : size;
      style.width = style.fontSize;
      style.height = style.fontSize;
    }

    return (
      <span styleName='care-icon' style={handleStylePx2rem(style)} onClick={this.handleClick}>
        <ReactSVG
          src={image}
          beforeInjection={(svg: any) => {
            if (color) {
              svg.querySelector('path')?.setAttribute('style', `fill: ${color}`);
            }
          }}
        />
      </span>
    )
  }
}

export default Icon;
